module.exports = __webpack_public_path__ + "img/pt-br_get.61868b6.png";